<script>
  import { fade } from "svelte/transition"
  import { _ } from "svelte-i18n"

  import { gsap, Back, Power1, Power2 } from "gsap"
  // import { onMount } from "svelte"

  import { state, planets, message, sounds, taxi, praxi } from "../js/stores.js"
  import { rocketEntry, rocketLaunch } from "../js/animations.js"

  $: if ($planets.length > 0 && $taxi !== undefined) {
    rocketEntry()
  }
  // onMount(() => {})

  function rocketLaunchAndReset() {
    $state.currentCell = 1
    $state.rocketFull = false
    $message = ""
    setTimeout(function () {
      $sounds.rocketLaunch.play()
    }, 2100)
    rocketLaunch()
  }
</script>

<div id="target_number">{$state.targetNum}</div>
<div id="solution1-anim">{$state.solution1}</div>
<div id="solution2-anim">{$state.solution2}</div>

<div class="rocket-container">
  <svg
    id="rocket"
    viewBox="0 0 429 553"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <!-- Common use case: embed HTML text into SVG -->

    <foreignObject x="145" y="285" width="250" height="280">
      <!--
      In the context of SVG embedded in an HTML document, the XHTML
      namespace could be omitted, but it is mandatory in the
      context of an SVG document
    -->
      <div xmlns="http://www.w3.org/1999/xhtml" class="fire" />
    </foreignObject>
    <g id="Rocket-new">
      <g id="flame">
        <path
          id="flame-large"
          d="M324.372 465.48C314.85 435.643 275.378 435.37 263.331
          465.48C251.283 495.59 274.294 528.755 294.444 553C316.075 522.841
          333.894 495.317 324.372 465.48Z"
          fill="#FB1E00"
        />
        <path
          id="flame-small"
          d="M312.807 464.343C307.821 443.061 280.665 439.447 273.727
          464.343C266.789 489.239 279.003 512.534 294.214 531C310.544 508.03
          317.794 485.625 312.807 464.343Z"
          fill="#FFAB2D"
        />
      </g>
      <g id="praxi">
        <rect
          id="Rectangle 1"
          y="102"
          width="266"
          height="100"
          rx="50"
          fill="#FF7940"
        />
        <g id="Ellipse 2">
          <circle id="solution1" cx="48" cy="152" r="33" fill="#97DD77" />
          <foreignObject x="15" y="119" width="66" height="66">
            <!--
            In the context of SVG embedded in an HTML document, the XHTML
            namespace could be omitted, but it is mandatory in the
            context of an SVG document
          -->
            <div
              xmlns="http://www.w3.org/1999/xhtml"
              class="num"
              id="solution1-inner"
            />
          </foreignObject>
        </g>
        <g id="Ellipse 3">
          <circle id="solution2" cx="160" cy="152" r="33" fill="#97DD77" />
          <foreignObject x="127" y="119" width="66" height="66">
            <!--
            In the context of SVG embedded in an HTML document, the XHTML
            namespace could be omitted, but it is mandatory in the
            context of an SVG document
          -->
            <div
              xmlns="http://www.w3.org/1999/xhtml"
              class="num"
              id="solution2-inner"
            />
          </foreignObject>
        </g>
        {#if $praxi === "prosthesi"}
          <path
            id="+"
            d="M107.688
          151.531H118.969V159.688H107.688V172.438H99.0938V159.688H87.7812V151.531H99.0938V139.312H107.688V151.531Z"
            fill="#A82626"
          />
        {:else}
          <path
            id="x"
            d="M105.344 147.281L111.031 137.188H120.688L111.062 153.75L121.094 171H111.406L105.375 160.375L99.375 171H89.6562L99.6875 153.75L90.0938 137.188H99.7812L105.344 147.281Z"
            fill="#A82626"
          />
        {/if}
      </g>
      <g id="Group 1">
        <g id="Group">
          <g id="Group_2">
            <g id="Group_3">
              <path
                id="Vector"
                d="M354.024 306.849C354.376 303.466 356.821 300.669 360.133
                299.884C363.438 299.103 366.891 300.486 368.727 303.353L417.743
                379.982C425.11 391.552 429.001 404.919 429.001
                418.638V504.001C429.001 507.384 426.876 510.399 423.689
                511.536C422.814 511.848 421.9 512.001 421.001 512.001C418.649
                512.001 416.36 510.962 414.806 509.067L344.486 423.118C343.142
                421.47 342.509 419.352 342.72 417.235L354.024 306.849Z"
                fill="#FF7940"
              />
            </g>
            <g id="Group_4">
              <path
                id="Vector_2"
                d="M231.977 306.849C231.625 303.466 229.18 300.669 225.868
                299.884C222.563 299.103 219.11 300.486 217.274 303.353L168.258
                379.982C160.891 391.552 157 404.919 157 418.638V504.001C157
                507.384 159.125 510.399 162.312 511.536C163.187 511.848 164.101
                512.001 165 512.001C167.352 512.001 169.641 510.962 171.195
                509.067L241.515 423.118C242.859 421.47 243.492 419.352 243.281
                417.235L231.977 306.849Z"
                fill="#FF7940"
              />
            </g>
            <g id="Group_5">
              <path
                id="Vector_3"
                d="M297.118 1.14301C294.587 -0.379987 291.415 -0.379987 288.884
                1.14301C285.462 3.19801 205.001 52.705 205.001 160.002C205.001
                203.326 215.767 318.596 230.048 428.127C232.118 444.018 245.751
                456.002 261.743 456.002H324.259C340.251 456.002 353.884 444.018
                355.954 428.127C370.235 318.596 381.001 203.326 381.001
                160.002C381.001 52.705 300.54 3.19701 297.118 1.14301Z"
                fill="#3DDFDF"
              />
            </g>
            <g id="Group_6">
              <path
                id="Vector_4"
                d="M288.884 1.143C286.596 2.517 249.904 25.132 225.813
                72.002H360.189C336.098 25.132 299.406 2.516 297.118
                1.143C294.587 -0.381 291.415 -0.381 288.884 1.143Z"
                fill="#FF7940"
              />
            </g>
          </g>
        </g>
      </g>
      <circle
        id="target-container"
        cx="293.5"
        cy="154.5"
        r="63"
        fill="white"
        fill-opacity="0.72"
        stroke="#FF7940"
        stroke-width="9"
      />

      <foreignObject x="230.5" y="91.5" width="126" height="126">
        <!--
      In the context of SVG embedded in an HTML document, the XHTML
      namespace could be omitted, but it is mandatory in the
      context of an SVG document
    -->
        <div
          xmlns="http://www.w3.org/1999/xhtml"
          class="num"
          id="target-inside-rocket"
        />
      </foreignObject>
      <foreignObject x="220" y="230" width="146" height="80">
        <!--
      In the context of SVG embedded in an HTML document, the XHTML
      namespace could be omitted, but it is mandatory in the
      context of an SVG document
    -->
        <div xmlns="http://www.w3.org/1999/xhtml" id="launch-container">
          {#if $state.rocketFull}
            <div
              xmlns="http://www.w3.org/1999/xhtml"
              id="launch-button"
              transition:fade
              on:click|once={rocketLaunchAndReset}
            >
              {$_("launch")}
            </div>
          {/if}
        </div>
      </foreignObject>
      <path
        id="fuelTank"
        d="M235.57 329.173C234.867 323.227 239.513 318 245.501
        318H340.499C346.487 318 351.133 323.227 350.43 329.173L338.265
        432.173C337.67 437.207 333.403 441 328.334 441H257.666C252.597 441
        248.33 437.207 247.735 432.173L235.57 329.173Z"
        fill="white"
        fill-opacity="0.72"
        stroke="#4ACE4F"
        stroke-width="4"
      />
      <path
        class="fuel-cell"
        id="fuel-cell1"
        d="M249.741 414.632C249.352 412.202 251.23 410 253.691
        410H333.121C335.645 410 337.538 412.309 337.043 414.784L333.643
        431.784C333.269 433.654 331.628 435 329.721 435H256.411C254.446 435
        252.772 433.572 252.461 431.632L249.741 414.632Z"
        fill="#7AD84D"
      />
      <path
        class="fuel-cell"
        id="fuel-cell2"
        d="M246.6 385.526C246.282 383.129 248.147 381 250.565
        381H335.236C337.722 381 339.606 383.244 339.175 385.692L336.188
        402.692C335.852 404.605 334.19 406 332.248 406H252.819C250.813 406
        249.118 404.514 248.854 402.526L246.6 385.526Z"
        fill="#7AD84D"
      />
      <path
        class="fuel-cell"
        id="fuel-cell3"
        d="M242.876 356.728C242.42 354.269 244.308 352 246.809
        352H339.968C342.542 352 344.446 354.395 343.865 356.902L339.931
        373.902C339.511 375.716 337.895 377 336.034 377H249.957C248.028 377
        246.374 375.624 246.023 373.728L242.876 356.728Z"
        fill="#7AD84D"
      />
      <path
        class="fuel-cell"
        id="fuel-cell4"
        d="M239.516 327.459C239.241 325.084 241.098 323 243.489
        323H342.29C344.758 323 346.637 325.213 346.237 327.648L343.446
        344.648C343.129 346.581 341.458 348 339.499 348H245.454C243.423 348
        241.714 346.477 241.481 344.459L239.516 327.459Z"
        fill="#7AD84D"
      />
    </g>
  </svg>
</div>

<style>
  .num {
    /* border: 1px solid red; */
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 4rem;
    color: #ff7940;
  }

  #target_number,
  #solution1-anim,
  #solution2-anim {
    font-size: 4rem;
    color: #ff7940;
    position: absolute;
    top: 0;
    left: 0;
    /* translate: (-50%, -50%); */
    z-index: 100;
    padding: 20px;
    /* background: #fff; */
    border-radius: 50%;
    opacity: 0;
    /* border: 1px solid red; */
    display: flex;
    align-items: center;
    justify-content: center;
  }

  #solution1-anim,
  #solution2-anim,
  #solution1-inner,
  #solution2-inner {
    font-size: 2.3rem;
    color: white;
  }

  #launch-container {
    /* background: lightgreen; */
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
  }

  #launch-button {
    /* position: absolute;
    z-index: 1000; */
    background: rgb(255, 47, 40);
    border: 5px solid rgb(165, 0, 0);
    padding: 8px 12px;
    border-radius: 20px;
    color: white;
    font-size: 18px;
    cursor: pointer;
  }

  #launch-button:hover {
    background: rgb(192, 6, 0);
  }

  .fuel-cell {
    opacity: 0;
  }

  .rocket-container {
    position: relative;

    --bluegreen: #ff4800;
    --bluewhite: #f3e77f;
  }
  #flame {
    display: none;
  }
  .fire {
    bottom: 80px;
    position: absolute;
    left: 60%;
    margin-left: -10px;
    width: 20px;
    height: 20px;
    border-radius: 80% 0 55% 50% / 55% 0 80% 50%;
    background-color: var(--bluegreen);
    transform: rotate(135deg) scale(2.2);
    margin-top: 20px;
    animation: flicker infinite 1s alternate ease-in-out;
  }

  .fire:after {
    content: "";
    top: 5px;
    position: absolute;
    width: 15px;
    height: 15px;
    border-radius: 80% 0 55% 50% / 55% 0 80% 50%;
    background-color: var(--bluewhite);
  }

  @keyframes flicker {
    0% {
      transform: rotate(135deg) scale(2);
      box-shadow: 0 0 12px 10px rgba(165, 238, 224, 0.5);
    }

    25% {
      box-shadow: 0 0 12px 5px rgba(165, 238, 224, 0.5);
    }

    50% {
      box-shadow: 0 0 12px 7px rgba(165, 238, 224, 0.5);
    }

    75% {
      box-shadow: 0 0 12px 5px rgba(165, 238, 224, 0.5);
    }

    100% {
      box-shadow: 0 0 12px 10px rgba(165, 238, 224, 0.5);
      /* transform: scale(2); */
    }
  }

  #rocket {
    width: 70vw;
    max-width: 400px;
  }

  @media (max-height: 800px) {
    #rocket {
      max-width: 320px;
    }
  }

  /* @media (max-height: 800px) and (min-width: 600px) {
    #rocket {
      width: 320px;
    }
  } */
</style>
